import React from "react";
import { familyBundles } from "../data/mock";
import { Plus, Star } from "lucide-react";
import { useCart } from "../context/CartContext";

function toNumber(p) {
  return parseFloat((p || "0").replace(/[^\d.]/g, "")) || 0;
}

export default function Bundles() {
  const { add } = useCart();
  return (
    <section id="bundles" className="py-24 md:py-32 border-t border-[var(--mm-line)]">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="text-center mb-14 fade-in">
          <div className="section-label mb-4">Meal Deals</div>
          <h2 className="font-display text-5xl md:text-7xl italic font-light text-[var(--mm-cream)] leading-[0.95]">
            Feast <span className="text-[var(--mm-accent)]">bundles.</span>
          </h2>
          <p className="text-[var(--mm-cream-muted)] mt-6 max-w-xl mx-auto font-light">
            Built to share. Save when you order a whole feast at once.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {familyBundles.map((b) => (
            <article key={b.id} className="fade-in group border border-[var(--mm-line)] bg-[var(--mm-bg-alt)] hover:border-[var(--mm-accent)] transition-colors">
              <div className="img-hover aspect-[4/3] overflow-hidden">
                <img src={b.image} alt={b.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div>
                    <div className="section-label mb-1">{b.tagline}</div>
                    <h3 className="font-display italic text-2xl text-[var(--mm-cream)] leading-tight">{b.name}</h3>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-display text-2xl text-[var(--mm-accent)]">{b.price}</div>
                    <div className="text-xs text-[var(--mm-cream-muted)] line-through">{b.originalPrice}</div>
                  </div>
                </div>
                <p className="text-sm text-[var(--mm-cream-muted)] font-light leading-relaxed mb-5">{b.description}</p>
                <button
                  onClick={() => add({ lookup_key: b.lookup_key, name: b.name, price: toNumber(b.price), image: b.image })}
                  className="w-full inline-flex items-center justify-center gap-2 py-3 border border-[var(--mm-accent)] text-[var(--mm-accent)] text-xs tracking-[0.24em] uppercase hover:bg-[var(--mm-accent)] hover:text-[var(--mm-bg)] transition-all duration-300"
                >
                  <Plus size={14} /> Add Bundle
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
